import React from 'react';
import PropTypes from 'prop-types';
import useSectionStyles from './sectionstyles';

import SettingCheckbox from './settingcheckbox';
import GeneralAutocomplete from '../../../components/generalautocomplete/generalautocomplete';
import HCCAutocomplete from '../../../components/hccautocomplete/hccautocomplete';
import CoderAutocomplete from '../../../components/coderautocomplete/coderautocomplete';

const AuditSection = ({
  contractSettingsData,
  boundActions,
  isACA
}) => {
  const {
    unvalidatedDxes,
    newCodeCategoryAudit,
    coderAudit,
    codeCategoryAudit,
    dxCodeAudit,
    selectedContract: { contractId, dateOfServiceStartDate }
  } = contractSettingsData;

  const classes = useSectionStyles();

  return (
    <div className={classes.audit}>
      <h5 style={{ margin: '0' }}><u>Audits</u></h5>

      {/* Unvalidated DX Audit */}
      <div>
        <SettingCheckbox
          name="unvalidatedDxes"
          isChecked={unvalidatedDxes.isChecked}
          text="Audit Unvalidated DXes"
          onChange={() => {
            unvalidatedDxes.isChecked
              ? boundActions.disableUnvalidatedDxAudit(contractId)
              : boundActions.enableUnvalidatedDxAudit(contractId)
          }}
        />
      </div>

      {/* New HCC Audit */}
      <div>
        <SettingCheckbox
          name="newCodeCategoryAudit"
          isChecked={newCodeCategoryAudit.isChecked}
          text="Audit New HCC(s) (Code Categories)"
          onChange={() => {
            newCodeCategoryAudit.isChecked
              ? boundActions.disableNewHCCAudit(contractId)
              : boundActions.enableNewHCCAudit(contractId)
          }}
        />
      </div>

      {/* Coder Audit */}
      <div>
        <SettingCheckbox
          name="coderAudit"
          isChecked={coderAudit.isChecked}
          text="Audit Coder(s)"
          onChange={() => {
            coderAudit.isChecked
              ? boundActions.disableCoderAudit(contractId)
              : boundActions.enableCoderAudit(contractId)
          }}
        />

        <div style={{ visibility: coderAudit.isChecked ? 'visible' : 'hidden'}}>
          <CoderAutocomplete
            dateOfService={dateOfServiceStartDate}
            selectedEncoding={coderAudit.auditedCoders}
            setSelectedEncoding={x => {
              if (x === null || x === undefined) return;
              boundActions.placeCoderOnAudit(contractId, x.coderId, x);
            }}
            handleDelete={(coderId, x) => {
              boundActions.removeCoderFromAudit(
                contractId,
                coderId,
                x
              );
            }}
          />
        </div>
      </div>

      {/* Code Category (CC / HCC) Audit */}
      <div>
        <SettingCheckbox
          name="codeCategoryAudit"
          isChecked={codeCategoryAudit.isChecked}
          text="Audit HCC(s) (Code Categories)"
          onChange={() => {
            codeCategoryAudit.isChecked
              ? boundActions.disableCCAudit(contractId)
              : boundActions.enableCCAudit(contractId)
          }}
        />

        <div style={{ visibility: codeCategoryAudit.isChecked ? 'visible' : 'hidden' }}>
          <HCCAutocomplete
            isACA={isACA}
            dateOfService={dateOfServiceStartDate}
            selectedEncoding={codeCategoryAudit.auditedCodeCategories}
            setSelectedEncoding={x => {
              if (x === null || x === undefined) return;
              boundActions.placeCCOnAudit(contractId, x.codeCategoryId, x);
            }}
            handleDelete={(codeCategoryId, x) => {
              boundActions.removeCCFromAudit(
                contractId,
                codeCategoryId,
                x
              );
            }}
            codeCategoryLabel='HCC'
          />
        </div>
      </div>

      {/* Dx Code Audit */}
      <div>
        <SettingCheckbox
          name="dxCodeAudit"
          isChecked={dxCodeAudit.isChecked}
          text="Audit DX Code(s)"
          onChange={() => {
            dxCodeAudit.isChecked
              ? boundActions.disableDxAudit(contractId)
              : boundActions.enableDxAudit(contractId)
          }}
        />

        <div style={{ visibility: dxCodeAudit.isChecked ? 'visible' : 'hidden' }}>
          <GeneralAutocomplete
            isACA={isACA}
            dateOfService={dateOfServiceStartDate}
            selectedEncoding={dxCodeAudit.auditedDxes}
            setSelectedEncoding={x => {
              if (x === null || x === undefined) return;
              boundActions.placeDxOnAudit(contractId, x.cmsCodeId, x);
            }}
            handleDelete={(cmsCodeId, x) => {
              boundActions.removeDxFromAudit(
                contractId,
                cmsCodeId,
                x
              );
            }}
          />
        </div>
      </div>
    </div>
  );
};

AuditSection.propTypes = {
  isACA: PropTypes.bool.isRequired
};

export default AuditSection;
